import React from 'react'
import { menu } from '../utils/types'
import A from '../glossary/A'

function FooterSiteMap() {
  const baseUri = "https://kichijouji-kyousei.jp/"
  const iconUri = baseUri + "kkc/wp-content/themes/kichijouji-kyousei/images/icon/"

  const topMenu: menu[] = [{ title: "TOP", link: "", listStyle: "none", color: "white" }, { title: "初めての方へ", link: "welcome", listStyle: "none", color: "white" },
  { title: "医院案内", link: "clinic", listStyle: "none", color: "white" }, { title: "院長紹介", link: "doctor", listStyle: "none", color: "white" },
  { title: "アクセス", link: "clinic#access", listStyle: "none", color: "white" }, { title: "新着情報", link: "news", listStyle: "none", color: "white" },
  { title: "当院のコロナ対策", link: "news/新型コロナウイルス感染症対策について", listStyle: "none", color: "white" }, { title: "お問い合わせ", link: "", listStyle: "none", color: "white" },
  { title: "求人情報", link: "recruit", listStyle: "none", color: "white" }, { title: "サイトマップ", link: "sitemap", listStyle: "none", color: "white" }]

  const medicalInfoMenu: menu[] = [{ title: "診療案内", listStyle: "none", color: "white" }, { title: "矯正歯科", link: "orthodontic", listStyle: "arrow", color: "#A99271" }, { title: "裏側矯正", link: "orthodontic/lingual", listStyle: "line", color: "white" },
  { title: "マウスピース矯正", link: "orthodontic/invisalign", listStyle: "line", color: "white" }, { title: "唇側矯正", link: "orthodontic/labial", listStyle: "line", color: "white" },
  { title: "部分矯正", link: "orthodontic/partial", listStyle: "line", color: "white" }, { title: "歯科矯正用アンカースクリュー", link: "orthodontic/micro-implant-anchora", listStyle: "line", color: "white" },
  { title: "矯正専門のメリット", link: "orthodontic/strong-point", listStyle: "line", color: "white" }, { title: "矯正治療費", link: "treatment-fee", listStyle: "line", color: "white" },
  { title: "よくあるご質問", link: "faq", listStyle: "line", color: "white" }, { title: "外科矯正", link: "orthodontic/surgery-first", listStyle: "line", color: "white" },
  { title: "症例", link: "case", listStyle: "line", color: "white" }]

  const others: menu[] = [{ title: "ガミースマイル", link: "gummy-smile", listStyle: "arrow", color: "#A99271" }, { title: "口ゴボ", link: "kuchigobo", listStyle: "arrow", color: "#A99271" },
  { title: "審美歯科", link: "treatment", listStyle: "arrow", color: "#A99271" }, { title: "こども矯正(小児矯正)", link: "pediatric", listStyle: "arrow", color: "#A99271" },
  { title: "MFT（口腔筋機能療法）", link: "mft", listStyle: "arrow", color: "#A99271" }, { title: "ダイレクトボンディング", link: "direct-bonding", listStyle: "arrow", color: "#A99271" },
  { title: "結婚前準備矯正", link: "bridal", listStyle: "arrow", color: "#A99271" }, { title: "エイジングケア矯正", link: "anti-aging", listStyle: "arrow", color: "#A99271" },
  { title: "リテーナー", link: "orthodontic/retainer/", listStyle: "arrow", color: "#A99271" }, { title: "矯正歯科用語集", link: "glossary", listStyle: "arrow", color: "#A99271" }]

  const all = [topMenu, medicalInfoMenu, others]

  const dedicatedPages: menu[] = [{ title: "親知らずの抜歯", link: "wisdom-tooth", listStyle: "none", color: "white" },
  { title: "インプラント", link: "implant", listStyle: "none", color: "white" }]

  return (
    <div className='bg-[#232730] py-14 px-6'>
      <nav className='grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 max-w-[940px] mx-auto'>
        {all.map((items, key) => {
          return (
            <ul key={key} className="mb-6">
              {items.map((item) => {
                return (
                  <li key={item.title} className='mb-3 flex'>
                    <a className='w-max' href={item.link ? baseUri + item.link : undefined}>
                      <div className='flex'>
                        {item.listStyle === "none" ? null :
                          <img className='mr-1' src={item.listStyle === "arrow" ? iconUri + "arrow-right-light.svg" : iconUri + "border-light.svg"} alt={item.title} />}
                        <p style={{ color: item.color }}>{item.title}</p>
                      </div>
                    </a>
                  </li>
                )
              })}
            </ul>
          )
        })}
        <div className='sm:col-span-3 sm:grid grid-cols-2 sm:place-items-center md:col-span-1 md:block'>
          {
            dedicatedPages.map((item) => {
              return (
                <div className='my-3 w-[80%] p-[2px] text-center' style={{ background: "linear-gradient(90deg, #5e4123, #c6ab7a)" }}>
                  <a className='w-max' href={baseUri + item.link}>
                    <p className='bg-[#232730] text-white py-2 font-serif text-[18px]'>{item.title}</p>
                  </a>
                </div>
              )
            })
          }
        </div>
      </nav>
    </div>
  )
}

export default FooterSiteMap